import { render, h } from 'preact';

import loadJsonScript from '../utils/load-json-script';

import EmbedApp from '../EmbedApp';
import parseQueryString from '../utils/parse-query-string';

const urlParams = new URLSearchParams(location.search);

const notes = loadJsonScript('notes_data');
const annotations = loadJsonScript('annotations_data');

const contestsFromParams = Array.from(urlParams.entries()).map(
  ([key, value]) => ({
    office: value,
    type: key,
  })
);

render(
  <EmbedApp
    selectedContests={contestsFromParams}
    annotations={annotations}
    notes={notes}
    embedType={'internal'}
  />,
  document.getElementById('app')
);
